<h1>
	Edit User Profile
</h1>

<form [formGroup]="personalInfoForm" (submit)="submit()" class="form-width">
	<div class="row">

		<input-username class="col-lg-12" [form]="personalInfoForm" [controlName]="'username'" [matLabel]="'Username'"
			[placeholder]="'Username'"></input-username>

		<input-email class="col-lg-12" [form]="personalInfoForm" [controlName]="'workEmail'" [matLabel]="'Work Email'"
			[placeholder]="'Work Email'">
		</input-email>

		<mat-form-field class="col-lg-8">
			<mat-label>
				First Name
			</mat-label>
			<input matInput type="string" placeholder="First Name" formControlName="firstName" />
		</mat-form-field>

		<mat-form-field class="col-lg-4">
			<mat-label>M.I.</mat-label>
			<input matInput type="string" placeholder="Middle Initial" formControlName="middleInitial" />
		</mat-form-field>
	</div>
	<div class="row">
		<mat-form-field class="col-lg-8">
			<mat-label>
				Last Name
			</mat-label>
			<input matInput type="string" placeholder="Last Name" formControlName="lastName" />
		</mat-form-field>

		<mat-form-field class="col-lg-4">
			<mat-label>
				Suffix
			</mat-label>
			<mat-select formControlName="suffix">
				<mat-option>No Suffix</mat-option>
				<mat-option *ngFor="let suffix of suffixes" [value]="suffix">
					{{ suffix }}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
	<div class="row">
		<mat-form-field class="col-lg-12">
			<mat-label>
				Work Title
			</mat-label>
			<input matInput type="string" placeholder="Work Title" formControlName="workTitle" />
		</mat-form-field>
	</div>

	<div class="row">
		<edit-party-contact-mechanism class="col-lg-12" *ngIf="user.PERSON?.PARTy?.ID"
			[partyId]="user.PERSON?.PARTy?.ID!" [enabledTypes]="['postalAddresses', 'phoneNumbers']" [type]="'People'"
			[(isEditing)]="isEditingPartyContactMechanisms" [filterAddressTypes]="['Work Address']"
			[filterPhoneNumberTypes]="['Home Phone', 'Cell Phone', 'Work Phone', 'Other Phone']"
			[removeAddressTypes]="['Birthplace Address']"
			(partyContactMechanismsChange)="partyContactMechanismsChange($event)">
		</edit-party-contact-mechanism>
	</div>
	<div class="col-lg-12">
		<hr />
		<button type="submit" class="margin-right-xs" mat-raised-button color="primary"
			[disabled]="!personalInfoForm.valid || isLoading || isDone || isEditingPartyContactMechanisms">

			<mat-icon *ngIf="isLoading && !msg.SUCCESS">
				<mat-spinner *ngIf="isLoading" diameter="20"> </mat-spinner>
			</mat-icon>
			<mat-icon *ngIf="msg.SUCCESS">
				done
			</mat-icon>
			Save
		</button>
		<button mat-raised-button routerLink="/account/user-profile">Go Back</button>
	</div>

	<div class="col-lg-12">
		<app-msg [msg]="userIdChangedMsg" *ngIf="userIdChangedMsg.MSG"></app-msg>
		<app-msg [msg]="msg"></app-msg>
	</div>
</form>